import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

const useStyles = theme => ({
  formControl: {
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(2)
  },
});

class RadioForm extends React.Component{

  constructor(props) {
    super(props);
    this.state = {
      value: this.props.list[0].id
    };
    this.props.handler(this.props.list[0].id);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event){
    this.setState({
      value: event.target.value
    });
    this.props.handler(event.target.value);
  };

  render(){
    const { classes } = this.props;
    return (
      <div>
        <FormControl component="fieldset" className={classes.formControl}>
          <RadioGroup aria-label={this.props.formName} name={this.props.formName} value={this.state.value} onChange={this.handleChange}>
            {
              this.props.list.map((option, index) => <FormControlLabel key={index} value={option.id} control={<Radio color="primary"/>} label={option.name} />
            )}
          </RadioGroup>
        </FormControl>
      </div>
    );
  }
}

export default withStyles(useStyles)(RadioForm);
